import React, { useContext } from 'react'
import { Dropdown } from 'components/Dropdown'
import { SelectContext } from './Select.context'
import type { SelectCreatableOptionProps } from './Select.types'

function SelectCreatableOption({ children, ...rest }: SelectCreatableOptionProps): JSX.Element {
  const select =
    useContext(SelectContext) ||
    (() => {
      throw new Error('SelectCreatableOption should be wrapped in a SelectContext')
    })()

  return (
    <Dropdown.Item {...rest} {...select.getCreatebleProps()}>
      {children || `Add "${select.query}"`}
    </Dropdown.Item>
  )
}

export default SelectCreatableOption
